import isEmpty from "lodash.isempty";

const checkACL = function(menuKey) {
  
  return true;
}

const isMenuAccessible = function(menuKey, aclLists) {
  return true;
}

const isPrimaryMenuAccessible = function(menuKey, menuType) {
  return true;
}

const merchantCreateMenu = ['ADD_MERCHANT']
const merchantViewMenu = ['LIST_MERCHANT', 'VIEW_MERCHANT', 'ARCHIVE_MERCHANT', 'EDIT_MERCHANT', 'W9INFO'];
const merchantMenu = [...merchantCreateMenu, ...merchantViewMenu]; 

const offerCreateMenu = ['ADD_CONTRACT'];
const contractMenu = ['LIST_CONTRACT', 'VIEW_CONTRACT', 'DELETE_CONTRACT', 'EDIT_CONTRACT', 'EXECUTE_CONTRACT'];
const viewOfferMenu = ['VIEW_OFFERS', 'EDIT_OFFER', 'DELETE_OFFER', 'VIEW_LEAD'];
const offerMenu = [...offerCreateMenu, ...contractMenu, ...viewOfferMenu];

const emailManagerMenu = ['LIST_COMPAIGN', 'IMPORT_SUBSCRIBER', 'EXPORT_SUBSCRIBER'];
const promoCodeMenu = ['LIST_PROMO_CODE', 'ADD_PROMO_CODE', 'DELETE_PROMO_CODE', 'EDIT_PROMO_CODE'];
const affiliatMenu = ['LIST_AFFILIATE', 'ADD_AFFILIATE', 'VIEW_AFFILIATE', 'DELETE_AFFILIATE', 'EDIT_AFFILIATE']
const storeMenu = ['STORES'];
const marketingMenu = [...emailManagerMenu, ...promoCodeMenu, ...affiliatMenu, ...storeMenu];

const generalMenu = ['GENERAL_SEARCH'];
const voucherMenu = ['LIST_VOUCHERS', 'GENERATE_VOUCHER', 'CHANGE_STATUS', 'EDIT_VOUCHER', 'TRANSFER_VOUCHER', 'REFUND_VOUCHER'];
const searchMenu = [...generalMenu, ...voucherMenu]; 

const merchantPayMenu = ['MERCHANT_PAYOUTS', 'MERCHANT_PAID_PAYOUTS']; 

const reportMenu = ['TRANSACTION_REPORT', 'SALES_REPORT', 'REFUNDS_REPORT', 'EMPLOYEE_COMISSIONS', 'PAY_ON_REDEMPTION', 'SALES_PERFORMANCE', 'BUYER_METRICS', 'AFFILIATE_COMMISSION', 'SUBSCRIBERS_REPORT', ...merchantPayMenu];
const merchantPayout = ['MERCHANT_PAYOUTS', 'MERCHANT_PAID_PAYOUTS']
const questionMenu = ['MANAGE_QUESTIONS', 'VIEW_QUESTION', 'GIVE_ANSWER', 'DELETE_QUESTION']
const reviewMenu = ['MANAGE_REVIEWS', 'EDIT_REVIEW', 'DELETE_REVIEW'];
const feedbackMenu = [...questionMenu, ...reviewMenu]; 

const settingMenu = ['EDIT_SITE', 'CITY_LISTING'];

const categoryMenu = ['LIST_CATEGORY', 'ADD_CATEGORY', 'VIEW_CATEGORY', 'DELETE_CATEGORY', 'EDIT_CATEGORY'];

const employeeMenu = ['LIST_EMPLOYEE', 'ADD_EMPLOYEE', 'VIEW_EMPLOYEE', 'DELETE_EMPLOYEE', 'EDIT_EMPLOYEE', 'MANAGE_ACL', 'MANAGE_ROLES'];

const roleMenu = ['MANAGE_ROLES', 'LIST_ROLES', 'ADD_ROLE', 'EDIT_ROLE', 'DELETE_ROLE'];


const assetMenu = ['LIST_ASSET', 'ADD_ASSET', 'DELETE_ASSET', 'EDIT_ASSET'];

const assetColorMenu = ['LIST_ASSET_COLOR', 'ADD_ASSET_COLOR', 'DELETE_ASSET_COLOR', 'EDIT_ASSET_COLOR'];

const faqMenu = ['LIST_FAQ', 'ADD_FAQ', 'DELETE_FAQ', 'EDIT_FAQ', 'VIEW_FAQ'];

const designCenterMenu = ['PAGE_TEMPLATE', 'EMAIL_TEMPLATE', 'EDIT_EMAIL_TEMPLATE', ...assetMenu, ...assetColorMenu, ...faqMenu];

const cherityMenu = ['CHARITY_ADD', 'CHARITY_LIST'];

const siteSettingMenu = [...cherityMenu, ...settingMenu, ...categoryMenu, ...employeeMenu, ...designCenterMenu, ...roleMenu];

const paymentsMenu = ['PAYMENT_SETTING','PAYMENT_TERMS'];

const apiseomainMenu = ['API_SETTINGS','SEO_SETTINGS','MAINTENANCE_MODE'];



export const aclUtil = {
  checkACL,
  isMenuAccessible,
  isPrimaryMenuAccessible,
  voucherMenu,
  merchantMenu,
  offerMenu,
  marketingMenu,
  searchMenu,
  reportMenu,
  feedbackMenu,
  siteSettingMenu,
  questionMenu,
  reviewMenu,
  designCenterMenu,
  faqMenu,
  assetColorMenu,
  assetMenu,
  employeeMenu,
  paymentsMenu,
  apiseomainMenu,
  merchantPayout,
  emailManagerMenu,
  cherityMenu
}


// WEBPACK FOOTER //
// ./src/app/views/util.js